import React, { useState, useContext } from 'react';
import { Alert, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import registerImg from '../assets/undraw_mobile_payments_re_7udl.svg';
import url from '../url.js';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';

export const Register = ({ open, setOpen, setOpenLogin }) => { 
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [data, setData] = useState({
        name: "",
        email: "",
        password: "",
        passwordConf: "",
        school: "未填寫",
        city: "未填寫"
    });

    const handleClose = () => {
        setOpen(false);
        setFile(null);
        setError('');
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (data.password !== data.passwordConf) {
            setError('密碼與確認密碼不符');
            return;
        }

        try {
            if (file) {
                // Handle batch registration
                const formData = new FormData();
                formData.append('file', file);
                await axios.post(`${url.backendHost}api/users/upload`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    withCredentials: true
                });
            } else {
                // Handle single registration - 確保必要欄位有值
                const signupData = {
                    email: data.email,
                    password: data.password,
                    passwordConf: data.passwordConf,
                    name: data.name || data.email.split('@')[0], // 如果沒有提供姓名，使用 email 前綴
                    school: data.school || '未填寫',
                    city: data.city || '未填寫'
                };
                await axios.post(`${url.backendHost}api/users/signup`, signupData, {
                    withCredentials: true
                });
            }
            
            handleClose();
            setOpenLogin(true);
        } catch (error) {
            console.error('Registration error:', error);
            if (!error.response) {
                setError('網路連線失敗，請確認網路連線後再試');
            } else {
                const msg = error.response?.data?.message || error.response?.data?.error;
                setError(typeof msg === 'string' ? msg : '註冊失敗，請稍後再試');
            }
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>註冊</DialogTitle>
            <DialogContent>
                <img src={registerImg} alt="Register" style={{ width: '100%', marginBottom: '20px' }} />
                <DialogContentText>
                    請填寫以下資訊完成註冊（最少資料即可）
                </DialogContentText>
                {error && (
                    <Alert severity="error" sx={{ mt: 1 }}>
                        {error}
                    </Alert>
                )}
                <TextField
                    autoFocus
                    margin="dense"
                    name="email"
                    label="電子郵件 *"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={data.email}
                    onChange={handleChange}
                    required
                />
                <TextField
                    margin="dense"
                    name="password"
                    label="密碼 *"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={data.password}
                    onChange={handleChange}
                    required
                />
                <TextField
                    margin="dense"
                    name="passwordConf"
                    label="確認密碼 *"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={data.passwordConf}
                    onChange={handleChange}
                    required
                />
                <TextField
                    margin="dense"
                    name="name"
                    label="姓名（選填）"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={data.name}
                    onChange={handleChange}
                    helperText="可稍後在個人資料中補充"
                />
                <TextField
                    margin="dense"
                    name="school"
                    label="學校（選填）"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={data.school}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    name="city"
                    label="城市（選填）"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={data.city}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>取消</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    註冊
                </Button>
            </DialogActions>
            <DialogContent>
                <DialogContentText>
                    已有帳號？{' '}
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            handleClose();
                            setOpenLogin(true);
                        }}
                    >
                        登入
                    </Link>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};